<template>
  <div class="Commontable">
    <Commontable class="overflow-y: scroll;" 
    :LNQNKZDGptionsDisabled="LNQNKZDGptionsDisabled"
     :LNZZDGptionsDisabled="LNZZDGptionsDisabled"
      :LNZCDGptionsDisabled="LNZCDGptionsDisabled"
       :YDTLDYGptionsDisabled="YDTLDYGptionsDisabled"
        :PQDYGptionsDisabled="PQDYGptionsDisabled" 
        :THQOptionsDisabled="THQOptionsDisabled" 
        :QSZJOptionsDisabled="QSZJOptionsDisabled"
         :YCXOptionsDisabled="YCXOptionsDisabled" 
         :DetailRemarkdisabled="DetailRemarkdisabled"
          @onRowClick="onRowClick" width="1000px" 
          colnum=7 :fontSizeTable="14" 
          :PTAOptionsDisabled="PTAOptionsDisabled" 
          :HPOptionsDisabled="HPOptionsDisabled" 
          :DCBOptionsDisabled="DCBOptionsDisabled" 
          :GCOptionsDisabled="GCOptionsDisabled"
          :tableData="tableData" :headerData="headerData"
           height="100%">
    </Commontable>
    <div class="pagination" v-if="false">
      <Pagination type="allColor" :paginationFalg="paginationFalg" @handleCurrentChange="handlePageIndexChange" @handleSizeChange="handleSizeChange" :total="total"></Pagination>
    </div>
  </div>
</template>
<script>
import Commontable from '../../../../../../../../components/common-table.vue'
import Pagination from '../../../../../../../../components/pagination.vue'
export default {
  components: { Commontable, Pagination },
  props: {
    tableData: {
      type: Array
    },
    headerData: {
      type: Array
    },
    total: {
      type: Number
    },
    paginationFalg: {
      type: Boolean,
      default: false
    },
    PTAOptionsDisabled: {
      type: Boolean,
      default: true
    },
    HPOptionsDisabled: {
      type: Boolean,
      default: true
    },
    DCBOptionsDisabled: {
      type: Boolean,
      default: true
    },
    GCOptionsDisabled: {
      type: Boolean,
      default: true
    },
    DetailRemarkdisabled: {
      type: Boolean,
      default: true
    },
    YCXOptionsDisabled: {
      type: Boolean,
      default: true
    },
    QSZJOptionsDisabled: {
      type: Boolean,
      default: true
    },
    THQOptionsDisabled: {
      type: Boolean,
      default: true
    },
    PQDYGptionsDisabled: {
      type: Boolean,
      default: true
    },
    YDTLDYGptionsDisabled: {
      type: Boolean,
      default: true
    },
    LNZCDGptionsDisabled: {
      type: Boolean,
      default: true
    },
    LNZZDGptionsDisabled: {
      type: Boolean,
      default: true
    },
    LNQNKZDGptionsDisabled: {
      type: Boolean,
      default: true
    },
   
     
  }, 
  data() {
    return {

    }
  },
  created() { },
  mounted() {
  },
  activated() { },
  updated() { },
  methods: {
    onRowClick(val) {
      this.$emit("onRowClick", val)
    },
    handlePageIndexChange(pageIndex) {
      this.$emit('handlePageIndexChange', pageIndex)
    },
    handleSizeChange(PageSize) {
      this.$emit('handleSizeChange', PageSize)
    }
  },
  computed: {},
  watch: {},
}
</script>
<style scoped lang='less'>
.Commontable {
  margin-left: -10px;
}
</style>